(() => {
  const countryCode = (value) => {
    if (typeof value !== 'string') return null;
    const code = value.trim().toUpperCase();
    return /^[A-Z]{2}$/.test(code) && !['XX', 'ZZ'].includes(code) ? code : null;
  };

  async function lookup(path, format) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3500);
    try {
      const response = await fetch(path, {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: controller.signal,
        headers: { Accept: format === 'json' ? 'application/json' : 'text/plain' }
      });
      if (!response.ok) return null;
      return await response[format]();
    } catch {
      return null;
    } finally {
      clearTimeout(timeout);
    }
  }

  async function detectAudience() {
    const root = window.Shopify?.routes?.root || '/';
    const context = await lookup(`${root}browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false`, 'json');
    let country = countryCode(context?.detected_values?.country?.handle);
    if (!country) {
      const trace = await lookup('/cdn-cgi/trace', 'text');
      country = countryCode(typeof trace === 'string' ? trace.match(/^loc=([A-Z]{2})\s*$/m)?.[1] : null);
    }
    if (!country) return;
    document.documentElement.dataset.hfAudience = country === 'PK' ? 'domestic' : 'international';
    window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
  }

  detectAudience();
})();
